import { useQuery } from '@urql/vue';

import type { UseAwardWalletBadgeFetchListParams } from '~/types/Award/badge';

import { awardWalletBadges } from '~/graphql/documents/awardWallet';
import { transformAwardWalletBadgeListItem } from '~/utils/transformers/badgeTransformers';
import { transformPagination } from '~/utils/transformers/paginationTransformers';

// API hooks

export const useAwardWalletBadgeFetchList = (params: Ref<UseAwardWalletBadgeFetchListParams>) => {
  const {
    data,
    fetching: isFetching,
    stale: isStale,
    error,
    executeQuery,
  } = useQuery({
    query: awardWalletBadges,
    variables: params,
  });

  const _badges = computed(() => data.value?.badges?.data.map(item => transformAwardWalletBadgeListItem(item)) ?? []);

  const paginatorInfo = computed(() => transformPagination(data.value?.badges?.paginatorInfo));

  return {
    items: _badges,
    paginatorInfo,
    error,
    isFetching,
    isStale,
    refetch: executeQuery,
  };
};
